import { useCallback } from 'react';
import { useTableTitle } from 'hooks/useTableTitle';
import { getText } from 'i18n/intl';
import type { OutlookConfigurationResponse } from '@timeedit/calendar-integration-api-contract';
import {
  Button,
  EditableTable,
  type EditableTableProps,
} from '@timeedit/ui-components';
import { Flex } from '@timeedit/ui-components/antd';
import { intlPrefix } from './MS365ConfigurationDetails';

type Props = EditableTableProps<OutlookConfigurationResponse> & {
  onCreate: () => void;
};

export function MS365ConfigurationList({ onCreate, ...props }: Props) {
  const footer = useCallback(
    () => (
      <Flex style={{ width: '100%' }} justify="space-between">
        <Flex gap="small" justify="flex-start">
          <Button size="small" type="primary" onClick={onCreate}>
            Create new
          </Button>
        </Flex>
      </Flex>
    ),
    [onCreate]
  );

  const title = useTableTitle({ total: props.dataSource?.length ?? 0 });

  return (
    <EditableTable<OutlookConfigurationResponse>
      columns={columns}
      footer={footer}
      pagination={false}
      title={title}
      {...props}
    />
  );
}

const columns = [
  {
    title: getText(`${intlPrefix}.form.name.label`),
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: getText(`${intlPrefix}.form.tenant_id.label`),
    dataIndex: 'tenantId',
    key: 'tenantId',
  },
  {
    title: getText(`${intlPrefix}.form.client_id.label`),
    dataIndex: 'clientId',
    key: 'clientId',
  },
];
